import React, { memo } from "react";
import { AvGroup } from "availity-reactstrap-validation";
import { StyledLabel } from "@aureskonnect/react-ui";
import classnames from "classnames";
import { ValidationMessage } from "./ValidationMessage";

import MultiCustomSelect from "@components/Common/MultiCustomSelect";

export const SaleSupportField = memo(
    ({
        t,
        salesSupportData,
        salesSupport,
        setSalesSupport,
        setIsEdited,
        inputSaleSupport,
        setInputSaleSupport,
    }: any) => (
        <AvGroup>
            <StyledLabel htmlFor="text" className="required__clz mt-3">
                {t("Sale support")}
            </StyledLabel>
            <MultiCustomSelect
                onDelete={() => setIsEdited(true)}
                result={salesSupport}
                setResult={setSalesSupport}
                data={salesSupportData}
                onChange={() => {
                    setIsEdited(true);
                    setInputSaleSupport(false);
                }}
                className={classnames("mdr_inp_FRsalesSupport", {
                    invalid__clz: inputSaleSupport,
                })}
                placeholder={`${t("Select")}…`}
                name="saleSupport"
                value={t("Choose")}
            />
            <ValidationMessage
                condition={inputSaleSupport}
                text={t("Please select a sale support")}
            />
        </AvGroup>
    )
);
